export * from "/__w/wiggot-web/wiggot-web/packages/web-components/charts/capital-gains/index.tsx"